export type ConfirmPasswordAdminValue = string | null;


export type confirmPasswordAdmin = {
    password?: ConfirmPasswordAdminValue | undefined;
    confirmPassword?: ConfirmPasswordAdminValue | undefined;
}